import React from 'react';

import styled from 'styled-components';

import { BookingOption, BookingOptionSubType } from '../../../types/Activity';
import Checkboxes from '../../utils/FormWidgets/Checkboxes';
import GroupedFormField from '../../utils/FormWidgets/FormGroup';

const StyledAttendeeRequirements = styled.section`
  display: flex;
  flex-direction: row;
`;

const StyledCheckbox = styled.section`
  padding-top: 30px;
`;

type Props = {
  fieldsValue: Partial<BookingOption>;
  noMaximumAttendees: boolean;
  onChange: (key: string, value: unknown) => void;
  setNoMaximumAttendees: (value: boolean) => void;
};

const AttendeeRequirements = ({
  fieldsValue,
  noMaximumAttendees,
  onChange,
  setNoMaximumAttendees,
}: Props) => {
  const isPerPartyAddon =
    fieldsValue.subType === BookingOptionSubType.addon &&
    fieldsValue.pricingModel === 'party';
  return (
    <StyledAttendeeRequirements>
      <GroupedFormField
        title='Min # of attendees'
        onChange={event => onChange('attendeesMinimum', +event.target.value)}
        value={fieldsValue.attendeesMinimum}
        type='number'
        disabled={isPerPartyAddon}
        min={1}
        style={{ marginRight: 20 }}
      />
      <GroupedFormField
        title='Max # of attendees*'
        onChange={event => onChange('attendeesMaximum', +event.target.value)}
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        value={noMaximumAttendees ? 'None' : fieldsValue.attendeesMaximum}
        type={noMaximumAttendees ? 'text' : 'number'}
        style={{ marginRight: 20 }}
        disabled={noMaximumAttendees || isPerPartyAddon}
      />
      <StyledCheckbox>
        {
          // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
          // @ts-ignore
          <Checkboxes
            label={'noMaxAttendees'}
            options={[{ value: true, label: 'No Maximum' }]}
            onChange={() => {
              setNoMaximumAttendees(!noMaximumAttendees);
              onChange('attendeesMaximum', !noMaximumAttendees ? null : 0);
            }}
            disabled={isPerPartyAddon}
            values={[noMaximumAttendees]}
          />
        }
      </StyledCheckbox>
    </StyledAttendeeRequirements>
  );
};

export default AttendeeRequirements;
